export class View {
  static Introduction = 'Introduction';
  static Home = 'Home';
}

export class StoryIntroState {
  static Hidden = 'StoryIntroHidden';
  static AnimatingIn = 'StoryIntroAnimatingIn';
  static AnimatingOut = 'StoryIntroAnimatingOut';
}

export class VideoIntroState {
  static Forward = 'VideoIntroForward';
  static Backward = 'VideoIntroBackward';
  static Paused = 'VideoIntroStopped';
  static Both = 'VideoIntroBoth';
}

export class PulseLocationState {
  static Waiting = 'PulseWaiting';
  static Active = 'PulseActive';
  static Inactive = 'PulseInactive';
}

export class LoadingState {
  static Waiting = 'LoadingWaiting';
  static Loading = 'Loading';
  static Loaded = 'Loaded';
}

export class NavbarContent {
  items = null;
  title = "";
  constructor(title, items) {
    this.title = title;
    this.items = items;
  }
}

export class NavbarLink {
  title = null;
  link = null;
  bold = false;
  key = -1;

  constructor(title, link, bold, key) {
    this.title = title;
    this.link = link;
    this.bold = bold;
    this.key = key;

  }
}

export const storyCardTypes = {
  VIDEO_INTRO: '0',
  TEXT_CAROUSEL: '1',
  TEXT_CAROUSEL_WITH_BG: '2',
  TEXT_IMAGE_CAROUSEL: '3',
  TEXT_VIDEO_CAROUSEL: '4',
  MIXED_MEDIA_CAROUSEL: '5',
  INFOGRAPHIC_CAROUSEL: '6',
  OBJECT_3D: '7',
  QUOTE: '8',
  VIDEO: '9',
  AUDIO_PODCAST: '10',
  AUDIO_MISC: '11',
  USER_POLL: '12',
};

export const pbpCardTypes = {
  INTRODUCTION: 'intro',
  PULSE: 'pulse',
  TIMELINE: 'timeline',
  CAROUSEL: 'carousel',
  RELATEDSTORIES: 'related-stories',
};

export const timelineSlideTypes = {
  IMAGE: '0',
  VIDEO: '1',
  OBJECT_3D: '2',
};

export const mixedMediaTypes = {
  IMAGE: '0',
  VIDEO: '1',
};

export const linkTypes = {
  EXTERNAL: "0",
  INTERNAL: "1",
};

export const introScreenNames = {
  LOADING: "loading",
  ANIMATION: "animation",
  TEXT_SCREEN: "text-screen",
  MENU_EXHIBITS: "menu-exhibits",
  STORY: "story",
  POST_STORIES: "post-stories",
};

export const scene3DAnimationType = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
};

export const swipeDirection = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
};

export const swipeType = {
  SCROLL: 'scroll',
  TOUCH: 'touch',
};

export const timelineAnchorPosition = {
  CENTER: "0",
  RIGHT: "1",
  LEFT: "2",
};

export const credoStoryTypes = {
  PhotoText: '0',
  PhotoTextCompany: '1',
  PhotoQuote: '2',
  VideoText: '3',
  PhotoQuoteCompany: '4',
  VideoTextCompany: '5'
};

export const innovationMediaTypes = {
  ImageOrGif: '0',
  Video: '1'
};
